<template>
  <v-layout justify-center>
    <v-alert
      outlined
      type="success"
      text
      transition="scale-transition"
      width="85%"
    >
      <h3 style="color: #155724" class="headline">Variation Found!</h3>
      <v-divider></v-divider>
      <br />
      <p>
        The variation {{ SKU }} is found! You have to complete an action with it
        to be able to move onto next item. The possible actions in this case for
        you are:
      </p>
      <p>
        -<a @click="writeDescription" style="font-weight: 700; color: #155724">
          Write description
        </a>
      </p>
      <p>
        -<a @click="skipDescription" style="font-weight: 700; color: #155724">
          Skip description
        </a>
      </p>
      <p>
        Click on one of the actions above to read more about them. You won't be
        allowed to continue until you complete one of this actions. You can also
        view the remaining information of this listing or check how it would
        look like on one of the platforms.
      </p>
    </v-alert>
  </v-layout>
</template>
<script>
export default {
  name: "AlertWithoutDesc",
  props: {
    SKU: String,
  },
  methods: {
    skipDescription() {
      this.$emit("skipDescription");
    },
    writeDescription() {
      this.$emit("writeDescription");
    },
  },
};
</script>